import React from 'react';
import { Header as HefoHeader } from '@juullabs/hefo';

import { showHeaderOverlay, hideHeaderOverlay } from 'apps/application/header';
import CartTrigger from 'apps/cart/wrapped/CartTrigger';

const Header = props => {
  const cartTrigger = () => {
    if (typeof window !== 'undefined') {
      return <CartTrigger />;
    }

    return null;
  };

  return (
    <HefoHeader
      {...props}
      cart={
        props.cart && {
          content: cartTrigger(),
        }
      }
      onDesktopDropdownOpen={showHeaderOverlay}
      onDesktopDropdownClose={hideHeaderOverlay}
    />
  );
};

export default Header;
